import { FF2Step, FormData } from "../types";
import { handlePurchaseStep } from "./purchase";
import { handleRemoStep } from "./remo";
import { handleSignupStep } from "./signup";
import { handleStartStep } from "./start";

export const calculateNextStep = (currentStep: FF2Step, formData: FormData): FF2Step => {
  let nextStep;

  switch (currentStep) {
    case FF2Step.Start:
      nextStep = handleStartStep(formData);
      break;
    case FF2Step.Purchase:
    case FF2Step.PurchaseToLet:
      nextStep = handlePurchaseStep(formData);
      break;
    case FF2Step.Remo:
      nextStep = handleRemoStep(formData);
      break;
    case FF2Step.MortgageTooSmallPurchase:
      nextStep = FF2Step.Purchase;
      break;
    case FF2Step.MortgageTooSmallRemo:
      nextStep = FF2Step.Remo;
      break;
    case FF2Step.Signup:
      nextStep = handleSignupStep(formData);
      break;
    default:
      nextStep = FF2Step.Start;
      break;
  }

  return nextStep;
};
